/* @flow */

export type $State = {
  selectedDealer: {
    outletId: string,
    position: string
  },
  previewedDealer: {
    outletId: string,
    position: string
  }
};

export const initialState: $State = {
  selectedDealer: {
    outletId: '',
    position: ''
  },
  previewedDealer: {
    outletId: '',
    position: ''
  }
};

export const ActionTypes = {
  DSW_SET_SELECTED_DEALER: 'dsw/dealer/DSW_SET_SELECTED_DEALER',
  DSW_UNSET_SELECTED_DEALER: 'dsw/dealer/DSW_UNSET_SELECTED_DEALER',
  DSW_SET_PREVIEWED_DEALER: 'dsw/dealer/DSW_SET_PREVIEWED_DEALER',
  DSW_UNSET_PREVIEWED_DEALER: 'dsw/dealer/DSW_UNSET_PREVIEWED_DEALER'
};

export type $Action =
  | { type: typeof ActionTypes.DSW_SET_SELECTED_DEALER, +selectedDealerId: string, +position: string }
  | { type: typeof ActionTypes.DSW_UNSET_SELECTED_DEALER }
  | { type: typeof ActionTypes.DSW_SET_PREVIEWED_DEALER, +previewedDealerId: string, +position: string }
  | { type: typeof ActionTypes.DSW_UNSET_PREVIEWED_DEALER }

export const setSelectedDealer = (selectedDealerId: string, position: string) => ({
  type: ActionTypes.DSW_SET_SELECTED_DEALER,
  selectedDealerId,
  position
});

export const unsetSelectedDealer = () => ({
  type: ActionTypes.DSW_UNSET_SELECTED_DEALER
});

export const setPreviewedDealer = (previewedDealerId: string, position: string) => ({
  type: ActionTypes.DSW_SET_PREVIEWED_DEALER,
  previewedDealerId,
  position
});

export const unsetPreviewedDealer = (ignoreTracking: boolean) => ({
  type: ActionTypes.DSW_UNSET_PREVIEWED_DEALER,
  ignoreTracking
});

export default function reducer(state: $State = initialState, action: $Action) {
  switch (action.type) {

    case ActionTypes.DSW_SET_SELECTED_DEALER:
      return {
        ...state,
        selectedDealer: {
          outletId: action.selectedDealerId,
          position: action.position
        }
      };

    case ActionTypes.DSW_UNSET_SELECTED_DEALER:
      return {
        ...state,
        selectedDealer: {
          outletId: '',
          position: ''
        }
      };

    case ActionTypes.DSW_SET_PREVIEWED_DEALER:
      return {
        ...state,
        previewedDealer: {
          outletId: action.previewedDealerId,
          position: action.position
        }
      };

    case ActionTypes.DSW_UNSET_PREVIEWED_DEALER:
      return {
        ...state,
        previewedDealer: {
          outletId: '',
          position: ''
        }
      };

    default:
      return state;
  }
}
